export default class Drawer {
  constructor() {
    this.drawer = document.querySelector('.js-drawer');
    this.drawerClose = document.querySelector('.c-nav__close');
    this.drawerTrigger = document.querySelector('.drawer-trigger');
    this.anchor = document.querySelectorAll('.js-anchorTarget');
    this.init();
  }
  init() {
    if (!this.drawerTrigger) return;
    this.drawerTrigger.addEventListener('click', () => {
      document.documentElement.classList.toggle('is-open');
    });
  }
}
